import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import { getUserGroup, isGreenTheme } from '../helpers/experiment';

const DEFAULT_TAGLINE = "Meal kits to your door every week.";
// Halo text for the green groups (G1, G3): the key claims are bolded.
const HALO_TAGLINE = (
  <>
    <strong>Nutritionally balanced</strong>, <strong>responsibly sourced</strong> meals delivered to your door every week.
  </>
);
const LEAF = <span className="store-tagline-leaf" aria-hidden="true">🌿</span>;
const COUNTDOWN_START_SECONDS = 125;
const COUNTDOWN_STORAGE_KEY = "store_countdown_start";

// Renders the countdown as boxed digit tiles, e.g. [0][0] H [0][2] M [0][5] S.
function renderCountdown(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const parts = [
    [hours, "H"],
    [minutes, "M"],
    [seconds, "S"],
  ];
  const label = `${hours} hours ${minutes} minutes ${seconds} seconds`;
  return (
    <span className="store-countdown" role="timer" aria-label={label}>
      {parts.map(([value, unit]) => (
        <React.Fragment key={unit}>
          {String(value).padStart(2, "0").split("").map((digit, idx) => (
            <span key={idx} className="store-countdown-digit" aria-hidden="true">{digit}</span>
          ))}
          <span className="store-countdown-unit" aria-hidden="true">{unit}</span>
        </React.Fragment>
      ))}
    </span>
  );
}

// The countdown must survive StoreNav remounting on every page navigation,
// so its start time is anchored to sessionStorage (wall clock) rather than
// per-component state. store-entry.component.js clears this key on a fresh
// login so a new participant always starts a new countdown.
function getSecondsLeft() {
  let startedAt = Number(sessionStorage.getItem(COUNTDOWN_STORAGE_KEY));
  if (!startedAt) {
    startedAt = Date.now();
    sessionStorage.setItem(COUNTDOWN_STORAGE_KEY, String(startedAt));
  }
  const elapsed = Math.floor((Date.now() - startedAt) / 1000);
  return Math.max(0, COUNTDOWN_START_SECONDS - elapsed);
}

class StoreNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsLeft: getSecondsLeft(),
    };
  }

  componentDidMount() {
    this.countdownInterval = setInterval(() => {
      this.setState({ secondsLeft: getSecondsLeft() });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
  }

  render() {
    const { basketCount, showBack } = this.props;
    const { secondsLeft } = this.state;
    const group = getUserGroup();
    const headerClassName = `store-header${isGreenTheme(group) ? " store-theme-green" : ""}`;

    const countdownSentence = (
      <>Order within {renderCountdown(secondsLeft)} for delivery at £2.95.</>
    );
    let tagline = `${DEFAULT_TAGLINE} Delivery at £2.95.`;
    if (group === 1) {
      tagline = <>{LEAF}{HALO_TAGLINE} Delivery at £2.95.{LEAF}</>;
    } else if (group === 2) {
      tagline = <>{DEFAULT_TAGLINE} {countdownSentence}</>;
    } else if (group === 3) {
      tagline = <>{LEAF}{HALO_TAGLINE} {countdownSentence}{LEAF}</>;
    }

    return (
      <div className={headerClassName}>
        <Navbar className="bg-body-tertiary navbar store-navbar">
          <Container className="store-navbar-grid">
            <div className="store-navbar-left">
              {showBack && <a href="/store" className="store-navbar-back">&larr;</a>}
            </div>
            <div className="store-navbar-center">
              <a href="/store" className="store-navbar-title">Kruzzlefood Market</a>
            </div>
            <div className="store-navbar-right">
              <a href="/store/basket" id="basket-link">
                🧺 Basket{typeof basketCount === "number" && basketCount > 0 ? ` (${basketCount})` : ""}
              </a>
            </div>
          </Container>
        </Navbar>
        <div className="store-tagline-bar">
          {tagline}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(StoreNav);
